import React from "react";
import { Tag, Tooltip } from "antd";
import { liveNow, windowLabel } from "./sectionWindow";

export const linkLabel = (banner) =>
  banner.item ? `Product: ${banner.item.name}` : banner.branch ? `Restaurant: ${banner.branch.name}` : "";

const HIDDEN = {
  out_of_reach: ["Hidden: restaurant out of reach", "Its restaurant doesn't deliver to the franchise centre, so customers there never see it."],
  restaurant_closed: ["Hidden now: restaurant closed", "A product banner shows only while its restaurant is open."],
  product_unavailable: ["Hidden now: product unavailable", "The product is out of stock, switched off or outside its time slot."],
  outside_times: ["Hidden now: outside its times", "The section shows only between its on and off times."],
  no_banner_showing: ["Hidden now: no banner can show", "None of its banners can show right now. Open it to see why."],
};

export const HiddenTag = ({ reason }) => {
  if (!HIDDEN[reason]) return null;
  const [label, why] = HIDDEN[reason];
  return (
    <Tooltip title={why}>
      <Tag color="orange">{label}</Tag>
    </Tooltip>
  );
};

export const WindowTags = ({ section }) => (
  <>
    <Tag>{windowLabel(section.visible_from, section.visible_to)}</Tag>
    {liveNow(section) && <Tag color="green">Showing now</Tag>}
  </>
);

export const ListRow = ({ children }) => (
  <div className="d-flex align-items-center flex-wrap border-bottom py-2" style={{ gap: 12 }}>{children}</div>
);
